import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSpecialistMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateSpecialistMutationPage = { readonly __typename?: 'RootMutationType', readonly createSpecialist: { readonly __typename?: 'AccountsSpecialist', readonly id: string } };

export type UpdateSpecialistMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateSpecialistMutationPage = { readonly __typename?: 'RootMutationType', readonly updateSpecialist: { readonly __typename?: 'AccountsSpecialist', readonly id: string } };

export type DeleteSpecialistMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSpecialistMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteSpecialist: boolean };


export const CreateSpecialistDocument = gql`
    mutation CreateSpecialist($name: String!, $email: String) {
  createSpecialist(name: $name, email: $email) {
    id
  }
}
    `;
export type CreateSpecialistMutationFn = Apollo.MutationFunction<CreateSpecialistMutationPage, CreateSpecialistMutationVariables>;

/**
 * __useCreateSpecialistMutation__
 *
 * To run a mutation, you first call `useCreateSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialistMutation, { data, loading, error }] = useCreateSpecialistMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpecialistMutationPage, CreateSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpecialistMutationPage, CreateSpecialistMutationVariables>(CreateSpecialistDocument, options);
      }
export type CreateSpecialistMutationHookResult = ReturnType<typeof useCreateSpecialistMutation>;
export type CreateSpecialistMutationResult = Apollo.MutationResult<CreateSpecialistMutationPage>;
export type CreateSpecialistMutationOptions = Apollo.BaseMutationOptions<CreateSpecialistMutationPage, CreateSpecialistMutationVariables>;
export const UpdateSpecialistDocument = gql`
    mutation UpdateSpecialist($id: ID!, $name: String!, $email: String) {
  updateSpecialist(id: $id, name: $name, email: $email) {
    id
  }
}
    `;
export type UpdateSpecialistMutationFn = Apollo.MutationFunction<UpdateSpecialistMutationPage, UpdateSpecialistMutationVariables>;

/**
 * __useUpdateSpecialistMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialistMutation, { data, loading, error }] = useUpdateSpecialistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpecialistMutationPage, UpdateSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpecialistMutationPage, UpdateSpecialistMutationVariables>(UpdateSpecialistDocument, options);
      }
export type UpdateSpecialistMutationHookResult = ReturnType<typeof useUpdateSpecialistMutation>;
export type UpdateSpecialistMutationResult = Apollo.MutationResult<UpdateSpecialistMutationPage>;
export type UpdateSpecialistMutationOptions = Apollo.BaseMutationOptions<UpdateSpecialistMutationPage, UpdateSpecialistMutationVariables>;
export const DeleteSpecialistDocument = gql`
    mutation DeleteSpecialist($id: ID!) {
  deleteSpecialist(id: $id)
}
    `;
export type DeleteSpecialistMutationFn = Apollo.MutationFunction<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>;

/**
 * __useDeleteSpecialistMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialistMutation, { data, loading, error }] = useDeleteSpecialistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpecialistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>(DeleteSpecialistDocument, options);
      }
export type DeleteSpecialistMutationHookResult = ReturnType<typeof useDeleteSpecialistMutation>;
export type DeleteSpecialistMutationResult = Apollo.MutationResult<DeleteSpecialistMutationPage>;
export type DeleteSpecialistMutationOptions = Apollo.BaseMutationOptions<DeleteSpecialistMutationPage, DeleteSpecialistMutationVariables>;